import { render, staticRenderFns } from "./ReportWidgetAdvice.vue?vue&type=template&id=78e7b1d7"
import script from "./ReportWidgetAdvice.vue?vue&type=script&lang=js"
export * from "./ReportWidgetAdvice.vue?vue&type=script&lang=js"
import style0 from "./ReportWidgetAdvice.vue?vue&type=style&index=0&id=78e7b1d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports